import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setListingConfig, setCheckoutOverlay } from '@/actions/ui';
import { fetchReservationIfNeeded } from '@/actions/reservation';
import AnalyticsContainer from './AnalyticsContainer';
import { hasSelectedChildEvent } from '../views/series/selectors/eventSeries';
import {
  isCurrentRouterState,
  shouldHideEmbeddedCart,
  shouldPinEmbeddedCart,
  showContinueCheckoutBanner,
} from '../selectors/ui';
import { getMainEvent } from '../selectors/event';
import { isDynamicListing } from '../selectors/dynamic-listing';
import ContinueCheckoutBannerContainer from '../../listing/containers/ContinueCheckoutBannerContainer';
import { EMBED_TYPE_MULTI } from '../reducers/ui';
import EmbedStateWrapper from './EmbedStateWrapper';
import CheckoutRoutes from '@/CheckoutRoutes';
import { withRouterCompat } from '@h/withRouterCompat';

class CheckoutContainer extends Component {
  state = {
    firedFirstTransitionHook: false,
  };

  componentDidMount() {
    this.props.setListingConfig(this.props.listingConfig);

        // handle the case where an embed configured to pin the cart loads with
        // the overlay closed and an active reservation and handle page refresh as well
        if (this.props.isEmbed) {
            this.props.fetchReservationIfNeeded().catch(() => {});
        }

    // Handle attempt to verify email
    const currentPath = this.props.router.locationService.path();
    if ((currentPath === '/auth/email') && (!this.props.overlay)) {
      this.props.setCheckoutOverlay(true);
    }
  }

  componentDidUpdate(prevProps) {
    //logic that depends on the first router state on app mount can go here
    if (!this.state.firedFirstTransitionHook && prevProps.lastState === null && this.props.lastState) {
      /**
       * if user refreshed, and we end up in a wacky state where we are viewing the ticket picker for a series
       * event with no child event selected, just close the checkout overlay, and force the user to start over
       */
      if (this.props.overlay && this.props.isRecurring && !this.props.hasSelectedChildEvent) {
        if (this.props.isTicketPicker) {
          this.props.setCheckoutOverlay(false);
        } else if (this.props.isSeriesDatePickerAndNoDateSelected) {
          this.props.setCheckoutOverlay(false);
          this.props.router.stateService.transitionTo('/');
        }
      }
      this.setState({ firedFirstTransitionHook: true });
    }
  }

  render() {
    let child = <div></div>;

    if (this.props.overlay) {
      child = <CheckoutRoutes />;
    } else if (this.props.shouldPinEmbeddedCart && this.props.showContinueCheckoutBanner) {
      child = <ContinueCheckoutBannerContainer />;
    }

    //lock page
    const pageElement = document.getElementById('page') || document.getElementById('checkout-inline');

    if (pageElement) {
      if (this.props.overlay) {
        document.body.classList.add('checkout-overlay--open');
        pageElement.setAttribute('aria-hidden', 'true');

        if (this.props.isMultiEmbed) {
          window.parent.scrollTo(0, 0);
          window.parent.document.body.classList.add('multi-overlay--open');
        }
      } else {
        document.body.classList.remove('checkout-overlay--open');
        pageElement.setAttribute('aria-hidden', 'false');

        if (this.props.isMultiEmbed) {
          window.parent.document.body.classList.remove('multi-overlay--open');
        }
      }
    }

    // let plugin = hashLocationPlugin;
    //
    // if(this.props.urlRouting === false || this.props.isEmbed) {
    //     plugin = memoryLocationPlugin;
    // }

    return (
      <div id="checkout-overlay">
        <div id="checkout__modal"></div>
              <AnalyticsContainer analytics={this.props.analytics}/>
              {this.props.isMultiEmbed && <EmbedStateWrapper />}
              {child}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let theEvent = getMainEvent(state) ?? null;
  return {
    isEmbed: !!state.ui.isEmbed,
    isDynamic: isDynamicListing(state),
    isMultiEmbed: !!state.ui.isEmbed && state.ui.embedType === EMBED_TYPE_MULTI,
    isSeriesDatePickerAndNoDateSelected:
      isCurrentRouterState('seriesDatePicker')(state) &&
      (!state.eventSeries.selectedDate || state.eventSeries.selectedDate === ''),
    overlay: state.ui.overlay,
    urlRouting: state.ui.urlRouting,
    confirmation: state.ui.confirmation,
    analytics: state.ui.uiConfig.analytics,
    isRecurring: theEvent ? theEvent.event.isRecurring : false,
    hasSelectedChildEvent: hasSelectedChildEvent(state),
    isTicketPicker: isCurrentRouterState('ticketPicker')(state),
    shouldPinEmbeddedCart: shouldPinEmbeddedCart(state),
    shouldHideEmbeddedCart: shouldHideEmbeddedCart(state),
    showContinueCheckoutBanner: showContinueCheckoutBanner(state),
    lastState:
      state.router && typeof state.router.last === 'object' && Object.keys(state.router.last).length
        ? state.router.last
        : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setListingConfig,
      setCheckoutOverlay,
      fetchReservationIfNeeded,
    },
    dispatch,
  );
};

CheckoutContainer.propTypes = {
  overlay: PropTypes.bool,
  confirmation: PropTypes.bool,
  listingConfig: PropTypes.object.isRequired,
};

export default withRouterCompat(connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer));

